export { withAssetPrefix } from '@/HOC/withAssetPrefix';
export { default as withAuth } from '@/HOC/auth.hoc';
